import React from "react";
import {getWeeks, renderPrintFooter} from "../../utils";
import Input from "../Input";
import {executeQuery} from "../../requests/executeQuery";
import {manageData} from "../../requests/CRUD";
import {BucketsColumnsModel} from "./bucketsColumnsModel";
import {columns, averageColumns} from "./columns";
import {STRIVE_BUCKETS, STRIVE_BUCKETS_PROPOSALS} from "../../consts/queries";
import {OVERFLOW_TABLE_WIDTH} from '../../consts/tables';
import {BUCKETS} from "../../consts/tables";
import './Buckets.scss';
import Alert from "../Alert";
import {Link} from "react-router";
import {stringUStoISO} from "../../date-converter";
import Icon from "../Icon";
import svgSortAsc from "../../svgs/arrow-up.svg";
import svgSortDesc from "../../svgs/arrow-down.svg";
import { can } from "../../access";

const cloneDeep = require('lodash.clonedeep');
const tableHeaderHeight = 48;

export default class Buckets extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rows: {},
            width: 1400,
            height: tableHeaderHeight,
            original: null,
            isBusy: null,
            error: null,
            success: null,
            isPrint: false,
            printBackground: '',
            sortOrder:{sortKey:'',order:'asc'}
        };

        this.tableRef = React.createRef();
        this.tableKeyRef = React.createRef();
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.updateTableWidth = this.updateTableWidth.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
    }

    componentDidMount() {
        this.updateTableWidth();
        this.setState({printBackground: `url('${arc.path.media+'Transaction_Background.png'}')`}, this.fetch);
        window.addEventListener('resize', this.updateTableWidth);
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateTableWidth);
    }

    beforePrint() {
        this.setState({isPrint: true});
    }

    afterPrint() {
        this.setState({isPrint: false});
    }

    static buildData(data, year, historyProposalsByAgent = {}) {
        const rows = {};
        data.map(row => {
            const historyProposals = historyProposalsByAgent[row.AGENT_ID] || 0;
            rows[row.AGENT_LAST_NAME + ' ' + row.AGENT_FIRST_NAME] = new BucketsColumnsModel(row, year, historyProposals);
        });
        return rows;
    }

    fetch() {
        this.setState({ isBusy: true, error: null });

        Promise.all([
            executeQuery({queryName: STRIVE_BUCKETS}),
            executeQuery({queryName: STRIVE_BUCKETS_PROPOSALS}),
        ]).then(([res, historyRes]) => {
            if (res && res.success && Array.isArray(res.data) && res.data.length) {
                const year = new Date().getFullYear();
                const historyProposalsByAgent = {};
                if (historyRes && historyRes.success && Array.isArray(historyRes.data)) {
                    historyRes.data.forEach(row => {
                        if (row && row.AGENT_ID) {
                            historyProposalsByAgent[row.AGENT_ID] = parseInt(row.HISTORY_PROPOSALS) || 0;
                        }
                    });
                }
                var rows = Buckets.buildData(res.data, year, historyProposalsByAgent);
                rows = Object.fromEntries(Object.entries(rows).sort((a, b) => {
                    const lastNameA = a[1].AGENT_LAST_NAME || '';
                    const lastNameB = b[1].AGENT_LAST_NAME || '';
                    const lastNameComparison = lastNameA.localeCompare(lastNameB);
                    if (lastNameComparison === 0) {
                        const firstNameA = a[1].AGENT_FIRST_NAME || '';
                        const firstNameB = b[1].AGENT_FIRST_NAME || '';
                        return firstNameA.localeCompare(firstNameB);
                    }
                    return lastNameComparison;
                }));

                this.setState({rows, original: cloneDeep(rows), error: null, isBusy: null}, () => {
                    const headerHeight = 40;
                    const headDetailsHeight = this.canEdit() ? 163 : 116;
                    const bottomSpaceHeight = 30;
                    let height = window.innerHeight - headerHeight - headDetailsHeight - bottomSpaceHeight;
                    if (height > this.tableRef.current.clientHeight && this.tableRef.current.clientHeight >= tableHeaderHeight) {
                        height = this.tableRef.current.clientHeight;
                    }
                    this.setState({height});
                });
            } else {
                this.setState({
                    error: res && res.message ? res.message : 'No bucket data returned',
                    isBusy: null,
                });
            }
        }).catch((err) => {
            console.error('Failed to load buckets', err);
            this.setState({
                error: err && err.message ? err.message : 'Failed to load buckets',
                isBusy: null,
            });
        });
    }

    handleChange(e, columnType) {
        const rows = cloneDeep(this.state.rows);
        const name = e.currentTarget.name.split('-');
        const rowKey = name[0];
        const colKey = name[1];
        if (columnType === 'date') {
            rows[rowKey][colKey] = e.currentTarget.value ? e.currentTarget.value.replace(/[^0-9/]/g, '') : '';
        } else {
            rows[rowKey][colKey] = e.currentTarget.value ? e.currentTarget.value.replace(/[^0-9.]/g, '') : '';
            rows[rowKey][`AVE_${colKey}`] = rows[rowKey][colKey] ? parseFloat(rows[rowKey][colKey] / rows[rowKey].WEEKS).toFixed(2) : 0;
        }
        this.setState({rows});
    }

    handleBlur(e, columnType) {
        const rows = cloneDeep(this.state.rows);
        const name = e.currentTarget.name.split('-');
        const rowKey = name[0];
        rows[rowKey].WEEKS = getWeeks(new Date(rows[rowKey].START_DATE), new Date());
        if (columnType === 'date')
            averageColumns.map(column => {
                const key = column.key.replace('AVE_', '');
                rows[rowKey][column.key] = rows[rowKey][key] ? parseFloat(rows[rowKey][key] / rows[rowKey].WEEKS).toFixed(2) : 0;
            });
        this.setState({rows});
    }

    handleSave() {
        if (this.state.isBusy) return;

        let rows = cloneDeep(this.state.rows);
        const columnsToSave = columns.filter(column => column.editable);
        const data = [];
        let index = 0;
        // Save only if updates exist
        Object.keys(rows).forEach(agent => {
            data[index] = {};
            columnsToSave.forEach(column => {
                if (column.type === 'date' && rows[agent][column.key])
                    rows[agent][column.key] = stringUStoISO(rows[agent][column.key]);
                if (rows[agent][column.key] !== this.state.original[agent][column.key])
                    data[index][column.key] = rows[agent][column.key];
            });

            if (Object.keys(data[index]).length)
                data[index++].AGENT_ID = rows[agent].AGENT_ID;
            else
                data.pop();
        });

        // No changes detected, nothing to do
        if (!data.length) {
            this.setState({
                isBusy: null,
                error: null,
                success: 'No data to update',
            });
            return;
        }

        this.setState({
            isBusy: true,
            error: null,
            success: null,
        });

        manageData({tableCode: BUCKETS, data}).then(res => {
            if (res && res.success) {
                this.setState({
                    isBusy: null,
                    success: 'Saved',
                    original: cloneDeep(rows),
                })
            } else {
                this.setState({
                    isBusy: null,
                    error: res && res.message ? res.message : 'Unspecified error',
                });
            }
        });
    }

    updateTableWidth() {
        this.setState({width: window.innerWidth - OVERFLOW_TABLE_WIDTH});
    }

    handleKeyDown(event, key, rowindex, rows, cols) {
        event.stopPropagation();
        const keys = Object.keys(rows);
        const id = event.target.getAttribute("id");

        let updatedId = id.substr(0, id.indexOf("+"));
        const name = event.target.getAttribute("data-name");
        const nameIndex = parseInt(event.target.getAttribute("data-index"));
        let rowid;
        let upkey;
        let upid;
        let nextEditableIndex = 0;
        switch (event.key) {
            case "ArrowUp":
            case 'Enter':
            case "ArrowDown":
                rowid = event.key == 'ArrowUp' ? rowindex - 1 : rowindex + 1;
                upkey = keys[rowid];
                upid = updatedId + "+" + rowid;
                upid = upid.replace(key, upkey);
                document.getElementById(upid).focus();
                break;
            case "ArrowLeft":
            case "ArrowRight":
                const keydownstart = event.target.selectionStart;
                const value = event.target.value;
                if (event.key === 'ArrowRight') {

                    if (value.length > keydownstart && keydownstart != value.length) {
                        return
                    }
                    for (let i = nameIndex + 1; i < cols.length; i++) {
                        if (cols[i].editable) {
                            nextEditableIndex = i;
                            break;
                        }
                    }
                } else {
                    if (value.length >= keydownstart && keydownstart != 0) {
                        return
                    }
                    for (let i = nameIndex - 1; i < cols.length; i--) {
                        if (cols[i].editable) {
                            nextEditableIndex = i;
                            break;
                        }
                    }
                }
                upid = updatedId + "+" + rowindex;
                upid = upid.replace(name, cols[nextEditableIndex].key);
                document.getElementById(upid).focus();
                break;
            default: break;
        }
    }

    sortBy(column) {
        const rows = [];
        const rowsData = cloneDeep(this.state.rows);
        
        const { sortKey, order } = this.state.sortOrder;
        let colOrder = order
        if(column.key == sortKey) {
            colOrder = colOrder == 'asc' ? 'dsc' : 'asc';
        } else {
            colOrder = 'asc';
        }
        let _rows = [];
        Object.keys(rowsData).forEach(function (key) {
            const obj = {
                AGENT_FULL_NAME: rowsData[key].AGENT_FULL_NAME,
                AGENT_ID: rowsData[key].AGENT_ID,
                AGENT_FIRST_NAME: rowsData[key].AGENT_FIRST_NAME,
                AGENT_LAST_NAME: rowsData[key].AGENT_LAST_NAME,
                AGENT_NAME: key,
                AVE_CALLS: rowsData[key].AVE_CALLS,
                AVE_MEETINGS: rowsData[key].AVE_MEETINGS,
                AVE_PROPOSALS: rowsData[key].AVE_PROPOSALS,
                CALLS: rowsData[key].CALLS,
                MEETINGS: rowsData[key].MEETINGS,
                PROPOSALS: rowsData[key].PROPOSALS,
                START_DATE: rowsData[key].START_DATE,
                TOTAL_CLOSED: rowsData[key].TOTAL_CLOSED,
                TOTAL_GROSS_FEE: rowsData[key].TOTAL_GROSS_FEE,
                TOTAL_LISTINGS: rowsData[key].TOTAL_LISTINGS,
                TOTAL_UC: rowsData[key].TOTAL_UC,
                WEEKS: rowsData[key].WEEKS,
            }

           
            rows.push(obj);
        })
        if (sortKey !== column.key || colOrder === 'asc') {
            _rows = rows.sort((a, b) => {
                let avalue = a[column.key];
                let bvalue = b[column.key];
                if (column.type === 'date') {
                    avalue = new Date(a[column.key]).valueOf();
                    bvalue = new Date(b[column.key]).valueOf();
                }
                else if(avalue != null && typeof(avalue)== 'string' && avalue.indexOf("$")!=-1){
                    avalue = parseFloat(a[column.key].trim().substr(1).replaceAll(",",""));
                    bvalue = parseFloat(b[column.key].trim().substr(1).replaceAll(",",""));
                }
                return avalue - bvalue;
            });
        }
        else {
            _rows = rows.sort((a, b) => {
                let avalue = a[column.key];
                let bvalue = b[column.key];
                if (column.type === 'date') {
                    avalue = new Date(a[column.key]).valueOf();
                    bvalue = new Date(b[column.key]).valueOf();
                }
                else if(avalue != null && typeof(avalue)== 'string' && avalue.indexOf("$")!=-1){
                    avalue = parseFloat(a[column.key].trim().substr(1).replaceAll(",",""));
                    bvalue = parseFloat(b[column.key].trim().substr(1).replaceAll(",",""));
                }
                return bvalue - avalue
            });
        }
        const  data = cloneDeep(rows)
        const copyrows={};
         data.forEach(row => {
            copyrows[row.AGENT_NAME] = row;
          
        });
        
        const sortOrder = {
            sortKey: column.key,
            order: colOrder
        }
        this.setState({ rows: copyrows, sortOrder })
    }   
    renderTable({ rows, cols, isPrintTable }) {
        
        return (
            <table className='table' ref={!isPrintTable && this.tableRef}>
                <thead>
                    <tr>
                        {
                            cols.map((column, index) => {
                                const { sortKey, order } = this.state.sortOrder;
                                if (index === 0)
                                    return <th key={index} className="Buckets_th border_top border_left" id='Buckets_first_cell'>{column.label}</th>;
                                return <th key={index} className="Buckets_th border_top">
                                    <div class="SortTable_th_name active">
                                        <button className="btn-text" onClick={(e)=> 
                                            this.sortBy(column)}> 
                                            <div
                                                                    className={`SortTable_th_name ${ sortKey == column.key && (order === "asc" || order === "dsc") ? "active" : ""}`}>
                                                                        <span
                                                                            className={`SortTable_th_name_icon top ${sortKey == column.key && order === "asc" ? "active" : ""}`}>
                                                                            <Icon svg={svgSortAsc}/>
                                                                        </span>
                                                                        {column.label}
                                                                    <span
                                                                        className={`SortTable_th_name_icon bottom ${sortKey == column.key && order === "dsc" ? "active" : ""}`}>
                                                                            <Icon svg={svgSortDesc}/>
                                                                        </span>
                                                                </div>
                                            
                                        </button>
                                                    </div>
                                                    </th>
                            })
                        }
                    </tr>
                </thead>
                <tbody ref={this.tableKeyRef}>
                    {
                        Object.keys(rows).map((key, rowindex) => {
                            if (!rows[key]) return;
                            return (
                                <tr key={key} className="Buckets_tr" onKeyDown={(e) => this.tableKeyRef && this.handleKeyDown(e, key, rowindex, rows, cols)}>
                                    {
                                        cols.map((column, index) => {
                                            if (index === 0)
                                                return (
                                                    <th key={key + '-' + index} className='Buckets_th agents border_left'>
                                                        <Link to={{ pathname: `${arc.path.base}buckets/${rows[key].AGENT_ID}`, state: { id: rows[key].AGENT_ID, name: rows[key].AGENT_FULL_NAME } }}>{rows[key].AGENT_FULL_NAME}</Link>
                                                    </th>
                                                );
                                            if (this.canEdit() && column.editable)
                                                return (
                                                    <td key={key + '-' + index} className={`Buckets_td ${column.hasHighlight ? 'highlighted' : ''}`}>
                                                        <Input data-index={index} data-name={column.key} theme={column.hasHighlight ? 'gray_without_border' : 'without_border'} className='Buckets_td' id={!isPrintTable ? key + '-' + column.key + '+' + rowindex : null} type='text' pattern={column.type === 'number' ? '^[0-9]*$' : ''} name={key + '-' + column.key} value={rows[key][column.key]} displayZero={true} onChange={(e) => this.handleChange(e, column.type)} onBlur={(e) => this.handleBlur(e, column.type)} tabIndex="0" />
                                                    </td>
                                                );
                                            return (
                                                <td key={key + '-' + index} className={`Buckets_td ${column.hasHighlight ? 'highlighted' : ''}`}>
                                                    {rows[key][column.key]} 
                                                </td>
                                            );
                                        })
                                    }
                                </tr>
                            );
                        })
                    }
                </tbody>
            </table>
        );
    }

    /** Edit the bucket figures: the member's level edits Buckets (summit.buckets = edit). */
    canEdit() {
        return can('summit.buckets', 'edit');
    }

    renderPrintPage({rows, cols, date, isPrint, printBackground}) {
        return (
            <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                <div className='Buckets_head_left'>
                    <h3 className='Buckets_h3'>SUMMIT Buckets</h3>
                    <h4 className='Buckets_h4'>{date}</h4>
                </div>
                <div className='table-print-container'>
                    {this.renderTable({rows, cols, isPrintTable: true})}
                </div>
                {renderPrintFooter(isPrint)}
            </div>
        )
    }

    render() {
        const {rows, isPrint, printBackground} = this.state;
        const canEdit = this.canEdit();
        const d = new Date();
        const date = d.getMonth()+1+'/'+d.getDate()+'/'+d.getFullYear();

        return (
            <div className='Buckets' data-is-busy={this.state.isBusy}>
                { this.state.success ? <Alert type='success' position='absolute'>{this.state.success}</Alert> : null }
                { this.state.error ? <Alert type='error' position='absolute'>{this.state.error}</Alert> : null }

                {this.renderPrintPage({rows, cols: columns, date, isPrint, printBackground})}
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>

                <div className='Buckets_head'>
                    <h3 className='Buckets_h3'>SUMMIT Buckets</h3>
                    <h4 className='Buckets_h4'>{date}</h4>
                    {canEdit ? <button className='Buckets_save' data-busy={this.state.isBusy} onClick={this.handleSave}>Save</button> : null }
                </div>
                <div className='Buckets_scroll_container' style={{width: this.state.width, height: this.state.height}}>
                    {this.renderTable({rows, cols: columns})}
                </div>
            </div>
        )
    }
}